import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { initialize } from '@ionic/core/components';
import { defineCustomElements } from '@ionic/core/loader';
import { AppModule } from './app/app.module';

initialize();
defineCustomElements(window);

platformBrowserDynamic().bootstrapModule(AppModule).catch((error) => console.error(error));
